// extracted by mini-css-extract-plugin
export default {"image":"CountryFlag_image_ml0YO"};